const SearchResultsMixin = {
  createWeightedResultList(results, center, weightDistance) {
    const scale = weightDistance;
    const decay = 0.5;
    const magicSortFactor = -2 * (Math.pow(scale, 2) / (2 * Math.log(decay)));
    let mapCenterLatLng;
    if (typeof L !== 'undefined') mapCenterLatLng = L.latLng(center[0], center[1]);
    else mapCenterLatLng = [center[0], center[1]];

    return results
      .map(result => {
        let distanceToCenter;
        if (typeof L !== 'undefined') distanceToCenter = mapCenterLatLng.distanceTo(L.latLng(result._geoloc.lat, result._geoloc.lng));
        else {
          const distanceBetweenLats = Math.pow(center[0] - result._geoloc.lat, 2);
          const distanceBetweenLngs = Math.pow(center[1] - result._geoloc.lng, 2);
          distanceToCenter = Math.sqrt(distanceBetweenLats + distanceBetweenLngs) * 111111;
        }
        result.adjustedPopularity = result.popularity * Math.exp((-1 * Math.pow(distanceToCenter, 2)) / magicSortFactor);
        return result;
      })
      .sort((a, b) => b.adjustedPopularity - a.adjustedPopularity);
  },
  createPopularResultList(results) {
    return results.sort((a, b) => b.popularity - a.popularity);
  },
  createClosestResultList(results, center) {
    const mapCenterLatLng = L.latLng(center[0], center[1]);
    return results
      .map(result => {
        result.distanceToCenter = mapCenterLatLng.distanceTo(L.latLng(result._geoloc.lat, result._geoloc.lng));
        return result;
      })
      .sort((a, b) => a.distanceToCenter - b.distanceToCenter);
  },
  sortByCustomListOrder(results, filters) {
    // TODO: Remove this.state reference and pass listId in instead, then move this to be a util instead of a mixin
    // favorite, completed, and custom list pages
    // sort by order field in reverse-order so new items show up on top
    return results.sort((a, b) => {
      a = this.getListItemInList(false, this.state.listId, a.type, a.ID);
      b = this.getListItemInList(false, this.state.listId, b.type, b.ID);
      if (filters.sort['list-order'].direction === 1) {
        return (b ? b.order : null) - (a ? a.order : null);
      } else {
        return (a ? a.order : null) - (b ? b.order : null);
      }
    });
  },
  sortByName(results, filters) {
    return results.sort((a, b) => {
      const nameA = a.name.toUpperCase();
      const nameB = b.name.toUpperCase();
      if (filters.sort.name.direction === 1) {
        if (nameA > nameB) return 1;
        if (nameA < nameB) return -1;
        return 0;
      }

      if (nameA < nameB) return 1;
      if (nameA > nameB) return -1;
      return 0;
    });
  },
  sortByDate(results, filters) {
    return results.sort((a, b) => {
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      if (filters.sort.date.direction === -1) return dateA - dateB;
      return dateB - dateA;
    });
  },
  applySortFunction(items, filters, center, weightDistance) {
    const selectedFilterKey = Object.keys(filters.sort).filter(itemKey => {
      return filters.sort[itemKey].selected;
    })[0];
    if (selectedFilterKey) {
      if (selectedFilterKey == 'best-match') return this.createWeightedResultList(items, center, weightDistance);
      if (selectedFilterKey == 'most-popular') return this.createPopularResultList(items);
      if (selectedFilterKey == 'closest') return this.createClosestResultList(items, center);
      if (selectedFilterKey == 'list-order') return this.sortByCustomListOrder(items, filters);
      if (selectedFilterKey == 'name') return this.sortByName(items, filters);
      if (selectedFilterKey == 'date') return this.sortByDate(items, filters);
    }
    return items;
  }
};

export { SearchResultsMixin };
